import compose from '@hypnosphi/recompose/compose';
import Tooltip from 'apollo-react/components/Tooltip';
import { withStyles } from '@mui/styles';
import { useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';

import { usePostmongerContext } from '../../contexts/PostmongerContext';

import TextField from 'apollo-react/components/TextField';

const styles = {
    section: {
      marginBottom: 32,
    },
  };

export const Traveler = (props, ref) => {
  const { t } = useTranslation();

  const isValid = () =>  {
    // Add validation here, including highlighting errors
    return true;
  };

  useImperativeHandle(ref, () => ({ isValid: () => isValid() }), []);  

  const  { classes } = props;

  const { inArguments, setDirty, disabled } = usePostmongerContext();

  const [communicationId, setCommunicationId] = useState(inArguments.get('communicationId'));

  const onCommunicationIdChange = event => 
  {
    setCommunicationId(event.target.value);
    inArguments.set('communicationId', event.target.value);
    setDirty();
  };

  return (
    <div className={classes.section}>
      <Tooltip title={t('traveler.communicationIdTooltip')}>
        <TextField
          fullWidth 
          label={t('traveler.communicationIdCaption')} 
          value={communicationId}
          disabled={disabled}
          onChange={onCommunicationIdChange}
        />
      </Tooltip>
    </div>
  )
};

export default compose(
    withStyles(styles)
    )(forwardRef(Traveler));